import { useState } from 'react';
import FlightA, { CONFIG as FLIGHT_A } from './FlightA';
import FlightB, { CONFIG as FLIGHT_B } from './FlightB';
import FlightStaticContent from '../components/FlightStaticContent';
import {
  resolveFlightVariant,
  trackAssignmentOnce,
  type FlightVariant,
} from '../lib/flight-analytics';

// The site landing: the scroll-flight experience, rendered directly at `/`
// (no redirect hop — the variant is resolved synchronously and the matching
// flight mounts immediately; index.html has already begun preloading its
// first scene). The classic page lives at /home, reachable via the flight's
// "Find out more" CTA. /flight-a and /flight-b remain as noindexed aliases
// for the Dawn/Night toggle and ?v= deep links.
export default function FlightLanding() {
  const [variant] = useState<FlightVariant>(() => {
    if (typeof window === 'undefined') return 'a';
    const resolved = resolveFlightVariant();
    // No navigation follows, so the (capped) promise needn't be awaited here.
    void trackAssignmentOnce(resolved.variant, resolved.source);
    return resolved.variant;
  });

  // The prerendered HTML (server resolves variant 'a') also carries the scene
  // copy as visually hidden semantic HTML for crawlers; on the client this
  // renders nothing and the engine draws the scenes (see FlightStaticContent).
  return (
    <>
      {variant === 'b' ? <FlightB landing /> : <FlightA landing />}
      <FlightStaticContent scenes={(variant === 'b' ? FLIGHT_B : FLIGHT_A).sections} />
    </>
  );
}
